import { getCurrentUser } from '../actions/user';

import {
  API_COMMENTS,
  API_SEND_EMAIL,
  API_SEND_AUDIENCES_BY_EMAIL,
  API_SEND_BY_EMAIL_AUDIENCES
} from '../constants/api';
import request from './api';

export const getComments = ({ contentId, ...params }) =>
  request(`${API_COMMENTS}comment/${contentId}`, {
    params,
    method: 'GET'
  });

export const insertComment = data =>
  request(`${API_COMMENTS}comment`, {
    data,
    method: 'POST'
  });

export const getReplies = commentId =>
  request(`${API_COMMENTS}comment/replies/${commentId}`, {
    method: 'GET'
  });

export const deleteComment = contentId =>
  request(`${API_COMMENTS}comment/${contentId}`, {
    method: 'DELETE'
  });
export const deleteCommentA3mil = contentId =>
  request(`${API_COMMENTS}sadmin/comment/${contentId}`, {
    method: 'DELETE'
  });
export const postLike = contentId =>
  request(`${API_COMMENTS}likes`, {
    data: {
      contentId
    },
    method: 'POST'
  });

export const deleteLike = contentId =>
  request(`${API_COMMENTS}likes/${contentId}`, {
    method: 'DELETE'
  });

export const postReadLater = contentId =>
  request(`${API_COMMENTS}readlater`, {
    data: {
      contentId
    },
    method: 'POST'
  });

export const deleteReadLater = contentId =>
  request(`${API_COMMENTS}readlater/${contentId}`, {
    method: 'DELETE'
  });

export const sendEmail = data =>
  request(API_SEND_EMAIL, {
    data,
    method: 'POST'
  });

export const sendAudiencesByEmail = data => {
  request(API_SEND_AUDIENCES_BY_EMAIL, {
    data,
    method: 'POST'
  });
};

export const sendByEmailAudiences = async data => {
  const currentUser = getCurrentUser();
  const userId = currentUser ? currentUser.userId : null;

  try {
    const response = await request(API_SEND_BY_EMAIL_AUDIENCES, {
      method: 'POST',
      data: {
        ...data
      },
      header: {
        userId
      }
    });

    return response;
  } catch (error) {
    throw error;
  }
};
